import { ETabs } from '../../types/redux/tabs';

export function getCardUrl(tab: ETabs, id: number) {
  return tab === ETabs.Realtors ? `/agents/${id}` : `/company/${id}`;
}
